import type { AxiosError, AxiosInstance } from "axios";

export function updateContentTypeV2Builder(apiClient: AxiosInstance) {
  return async function updateContentTypeV2(
    id: string,
    data: {
      content: any;
    },
  ): Promise<any> {
    try {
      const response = await apiClient.put(`/v2/pages/${id}/`, { ...data });
      return response.data;
    } catch (error: unknown) {
      if ((error as AxiosError).response?.status === 404) {
        return null;
      } else {
        throw error;
      }
    }
  };
}
